import { render, staticRenderFns } from "./MyPayPerksScreens.vue?vue&type=template&id=0f27bcfd&scoped=true&"
import script from "./MyPayPerksScreens.vue?vue&type=script&lang=js&"
export * from "./MyPayPerksScreens.vue?vue&type=script&lang=js&"
import style0 from "./MyPayPerksScreens.vue?vue&type=style&index=0&id=0f27bcfd&scoped=true&lang=css&"
import style1 from "./MyPayPerksScreens.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f27bcfd",
  null
  
)

export default component.exports